import { userHasFeature, type UserSession } from '@solinkcorp/authentication';
import FeaturesUtil from 'utils/FeaturesUtil';
import { getSiteFeatures } from './LocationUtil';
import { type VideoDiscoverySite } from './types';

export function doesAtleastOnSiteHaveVideoSearchEnabled(locations: VideoDiscoverySite[]) {
  return getSiteFeatures(locations.flatMap((location) => location.devices ?? []))?.videoSearch
    ?.enabled;
}

export function hasAccessToVideoSearch(user: UserSession, locations: VideoDiscoverySite[]) {
  if (FeaturesUtil.isLiveViewOnly()) return false;
  // eslint-disable-next-line
  // @ts-ignore: user feature not yet defined in user feature standard
  return userHasFeature(user, 'videoSearch') && doesAtleastOnSiteHaveVideoSearchEnabled(locations);
}
